/**
 * This file is part of Discorch.
 * Copyright (C) 2025 Discorch Contributors.
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as published
 * by the Free Software Foundation, either version 3 of the License, or
 * (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE. See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program. If not, see <https://www.gnu.org/licenses/>.
 */

import { AlertTriangle, ExternalLink } from "lucide-react";

export function Banner() {
  return (
    <div className="border-b border-yellow-500/20 bg-yellow-500/10 px-4 py-3">
      <div className="mx-auto max-w-5xl">
        <div className="flex items-start gap-3 text-sm">
          <AlertTriangle className="mt-0.5 h-4 w-4 shrink-0 text-yellow-600 dark:text-yellow-500" />
          <div className="space-y-2">
            <p className="font-medium text-yellow-800 dark:text-yellow-200">
              Important: Discord's limitations for message deletion
            </p>
            <div className="space-y-1 text-yellow-700 dark:text-yellow-300">
              <p>
                • Discord <strong>refuses to delete 1:1 DMs</strong> via privacy
                requests — use{" "}
                <a
                  href="https://github.com/Darker-Ink/DiscorchDeleter"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-flex items-center gap-1 underline hover:no-underline"
                >
                  DiscorchDeleter
                  <ExternalLink className="h-3 w-3" />
                </a>{" "}
                instead
              </p>
              <p>
                • You must <strong>leave servers and group DMs</strong> before
                Discord will delete messages from them
              </p>
              <p>
                • This tool helps with the privacy request process for
                server/group DM messages only
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
